import { TextField } from "@mui/material";

export default function MeasuredSoilHorizonInput({ value, onChange, disabled, error }) {
  return <details className="mb-5" open={error || undefined}>
    <summary className="cursor-pointer font-semibold text-sm">Optional measured soil horizon</summary>
    <p className="my-3 text-xs leading-5 text-slate-600">Record the physical thickness of the first soil horizon below surface litter. A soil sample’s depth does not establish this thickness. Holos SLC soil lookup supplies its own horizon; a custom soil source can capture this measurement.</p>
    <TextField fullWidth size="small" type="number" label="Measured topsoil horizon thickness [cm]"
      value={value ?? ""} onChange={event => onChange(event.target.value)} disabled={disabled}
      error={Boolean(error)} inputProps={{ min: 0, max: 1000, step: "any" }}
      helperText={error ? "Enter a positive thickness up to 1,000 cm, or leave blank." : "Optional. Saved in cm; converted to mm only when selecting a custom soil source."} />
  </details>;
}
